import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import type * as React from 'react';

const metadataStyle = css`
	margin: 0;
	font-family: ${theme.fonts.body};
	font-size: ${theme.fontSizes.small};
	color: ${theme.colors.inkSecondary};
`;

type Props = {
	readonly children: React.ReactNode;
};

/** The line of plain-text metadata under the title of a list card. */
const SubjectCardMetadata: React.FC<Props> = ({ children }) => {
	return <p css={metadataStyle}>{children}</p>;
};

export default SubjectCardMetadata;
